import { Store } from '@ngrx/store';
import { Observable, of, throwError } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { LoadStatus } from '../load-status';
import { selectAppConfigStatus } from './selectors/app-config.selector';

/**
 * Resolves once the app-config slice has settled: completes on success, errors on failure.
 * Mirrors the tail of `ConfigService.init()` (`config.ngrx.service.ts`), but is dispatch-free —
 * the caller dispatches `loadAppConfig()` itself, so this is a pure function over the store and
 * nothing is lost when the last caller (`InitializationService.attachAppConfigInit`) goes away.
 */
export function awaitAppConfigSettled(store: Store): Observable<void> {
    return store.select(selectAppConfigStatus).pipe(
        filter((status) => status === LoadStatus.Loaded || status === LoadStatus.Error),
        take(1),
        switchMap((status) =>
            status === LoadStatus.Error ? throwError(() => new Error('AppConfig: load failed')) : of(undefined as void),
        ),
    );
}
